import { ChevronRight as ChevronRightIcon } from "@tamagui/lucide-icons";
import { Body2, BrandGraphic, Card, Icon, RowLayout, SkeletonBlock, SkeletonText, Subtitle1 } from "@medbillai/ui";
import type { CtaGraphic } from "./CtaHeroCard";
type CtaSecondaryTileContent = {
  loading?: false;
  title: string;
  description: string;
  onPress: () => void;
  graphic: CtaGraphic;
};
export type CtaSecondaryTileProps = {
  testID?: string;
} & (CtaSecondaryTileContent | {
  loading: true;
});
export function CtaSecondaryTile(props: CtaSecondaryTileProps) {
  const loading = props.loading === true;
  return <Card variant="outlined" size="large" testID={props.testID} onPress={props.loading ? undefined : props.onPress} aria-busy={loading || undefined} data-sentry-element="Card" data-sentry-component="CtaSecondaryTile" data-sentry-source-file="CtaSecondaryTile.tsx">
      <RowLayout leading={props.loading ? <SkeletonBlock width="$si6" height="$si6" radius="$br2" /> : <BrandGraphic {...props.graphic} size="$si6" />} primary={<SkeletonText loading={loading} chars={18}>
            <Subtitle1 color="$textDefault">
              {props.loading ? undefined : props.title}
            </Subtitle1>
          </SkeletonText>} secondary={<SkeletonText loading={loading} chars={26}>
            <Body2 color="$textSubtle" numberOfLines={2}>
              {props.loading ? undefined : props.description}
            </Body2>
          </SkeletonText>} rowTrailing={loading ? null : <Icon icon={ChevronRightIcon} size="$iconLarge" color="$iconDefault" />} data-sentry-element="RowLayout" data-sentry-source-file="CtaSecondaryTile.tsx" />
    </Card>;
}